export default function Background({ bg }) {
  return (
    bg && (
      <div className={'button__bg custom-button__bg'}>
        <img src={bg} alt={''} />
      </div>
    )
  );
}
